<template>
  <div
    style="
      width: 2954px;
      height: 2056px;
      background: url(/static/img/cert.jpg);
      margin: 0 auto;
      text-align: unset;
    "
  >
    <div style="left: 704px;
    top: 374px; position: relative;text-align: left;">
      <img
        :src="`${global.remoteIp}/uploads/${cert.picsrc}?t=${Math.random()}`"
        width="300px"
        height="410px"
      />
      <!-- <img
      style="    position: relative;
    left: -230px;
    top: 181px;"
        src="/static/img/zhang.png"
      /> -->
    </div>
    <div
      class="text"
      style="     left: 542px;
    top: 512px;
    position: relative;
    width: 450px;"
    >
      <p>{{ cert.name }}</p>
    </div>
     <div
      class="text"
      style="    left: 1120px;
    top: 451px;
    position: relative;
    width: 250px;"
    >
      <p>{{ cert.sex }}</p>
    </div>
    <div
      class="text"
      style="left: 540px;top: 527px;position: relative;width: 830px;"
    >
      <p>{{ cert.cardtid }}</p>
    </div>
        <div
      :class="cert.position&&cert.position.length>17?'textchang':'text'"
      style="left: 540px;top: 594px;position: relative;width: 830px;"
    >
      <p>{{ cert.position }}</p>
    </div>
    <div
      class="text"
      style="left: 540px;top: 669px;position: relative;width: 830px;"
    >
      <p>{{ cert.level }}</p>
    </div>
    
    <div
      class="text"
      style="left: 540px;top: 748px;position: relative;width: 830px;"
    >
      <p>{{ cert.code }}</p>
    </div>
    <div
      class="text"
      style="left: 1901.9px;top: 874px;position: relative;width: 705px;"
    >
      <p>www.pjzx.org.cn</p>
    </div>
    <div
      class="text"
      style="left: 540px;top: 747px;position: relative;width: 830px;"
    >
      <p>{{ cert.company?cert.company:'&nbsp;' }}</p>
    </div>
    <div
      class="text"
      style="left: 1905.9px;top: 827px;position: relative;width: 705px;font-size: 36px;"
    >
      <p>{{ cert.certtime }}</p>
    </div>
    <div :style="`left: 1658.9px;top: 506px;position: relative;width: 705px;font-size: 36px;text-align: left;`">
      <div
        class="qrcode"
        ref="qrCodeUrl"
        width="200px"
        height="200px"
        style=""
      ></div>
    </div>
    <div
      class="text1"
      :style="`left: 1660.9px;top: 522px;position: relative;width: 200px;font-size: 36px;`"
    >
      <p>扫码查询</p>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      cert: {level:""},
      global,
      company: "XXXXXXXXXXXXXXXX",
      socilacredit: "XXXXXXXXXXXXXXXXXX",
      smallflag: false,
      fontSize:48
    };
  },
  methods: {
    creatQrCode(code, name) {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: encodeURI(
          `http://www.pjzx.org.cn/certResult?code=${code}&name=${name}`
        ), // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    setPositionWidth(){
      this.$nextTick(function(){
        // var div = document.getElementById("positiontextid");
        // var w = $("#positiontextid").css('width');    // 返回元素的总宽度
        
        // w=w.slice(0,w.length-2)
        let textlen = this.cert.position.replace(/[\u0391-\uFFE5]/g,"aa").length;
        console.log("text len ",textlen)
        var w = textlen*(this.fontSize/2)
        console.log("www",w)
        if(parseInt(w)>608)
        {
         // console.log(document.getElementById('zoom').style.fontSize);
         document.getElementById('positiontextid').style.fontSize=--this.fontSize+"px";
         this.setPositionWidth();
        }else{
          return;
        }
      })
    }
  },
  mounted() {
    this.cert = this.$route.query;
    // this.cert = {
    //   name: "李杏",
    //   sex: "男",
    //   birthday: "1984年05月08日",
    //   cardtid: "412822198405086639",
    //   position: "城市道路地下病害体综合检测与风险评估工程师（高级）",
    //   level: "高级工程师",
    //   code: "ZBX20220539",
    //   certtime: "2021年07月08日",
    //   company: "雅生活智慧城市服务股份有限公司无锡分公司",
    //   socilacredit: "91440300MA5G0MRG39",
    // };
    this.creatQrCode(this.cert.code, this.cert.name);
  },
};
</script>

<style scoped>
.positiontext {
  text-align: center;
  font-size: 48px;
  font-family: STZhongsong;
  font-weight: 900;
}
.leveltext {
  text-align: center;
  font-size: 48px;
  font-family: STZhongsong;
  color: #fc091f;
  font-weight: 900;
}
.text {
  text-align: center;
  font-size: 45px;
  font-family: STZhongsong;
}
.companytext {
  text-align: center;
  font-size: 27px;
  font-family: STZhongsong;
  font-weight: 900;
}
.companytextsmall {
  text-align: center;
  font-size: 18px;
  font-family: STZhongsong;
  font-weight: 900;
}
.companyposit
{
  left: -3px; top: 60px; position: relative; width: 794px
}
.companypositsmall
{
  left: -3px; top: 81px; position: relative; width: 794px
}
.soltext {
  text-align: center;
  font-size: 18.5px;
  font-family: STZhongsong;
  color: #fc091f;
  font-weight: 900;
}
.soltextsmall {
  text-align: center;
  font-size: 20px;
  font-family: STZhongsong;
  color: #fc091f;
  font-weight: 900;
}
.soltpositsmall
{
  left: -1px; top: 62px; position: relative; width: 794
}
.soltposit{
  left: -1px; top: 33px; position: relative; width: 794
}
.text1 {
  text-align: center;
  font-size: 35px;
  font-family: STZhongsong;
}
.text2 {
  text-align: left;
  font-size: 20px;
  font-family: STZhongsong;
}
.qrcode {
  display: inline-block;
}
.qrcode /deep/ canvas img {
  background-color: #fff;
  padding: 6px;
  box-sizing: border-box;
}

/*
    /createCert?name=王章伟&sex=男&birthday=2021年02月23日&cardtid=340825199508021014&position=软件工程师&level=高级&code=123456&certtime=021年02月23日&picsrc=202006282342320.jpeg
*/
.textchang{
text-align: center;
    font-size: 30px;
    font-family: STZhongsong;
    line-height: 62px;
}
</style>
